import { useTranslation } from 'react-i18next';

export default function WindowsServices() {
  const { t } = useTranslation();

  const serviceTypes = [
    {
      icon: 'ri-home-4-line',
      titleKey: 'wns1_title',
      descKey: 'wns1_desc',
      features: ['wns1_f1', 'wns1_f2', 'wns1_f3', 'wns1_f4'],
      img: 'https://public.readdy.ai/ai/img_res/409cef3140edff949e23bb8e4855effd.jpg',
    },
    {
      icon: 'ri-refresh-line',
      titleKey: 'wns2_title',
      descKey: 'wns2_desc',
      features: ['wns2_f1', 'wns2_f2', 'wns2_f3', 'wns2_f4'],
      img: 'https://readdy.ai/api/search-image?query=before%20and%20after%20window%20replacement%20transformation%20on%20American%20home%2C%20old%20deteriorated%20window%20being%20replaced%20with%20new%20modern%20energy%20efficient%20white%20frame%20window%2C%20professional%20home%20renovation%20photography&width=600&height=400&seq=orpm-replacement-v2&orientation=landscape',
    },
    {
      icon: 'ri-building-2-line',
      titleKey: 'wns3_title',
      descKey: 'wns3_desc',
      features: ['wns3_f1', 'wns3_f2', 'wns3_f3', 'wns3_f4'],
      img: 'https://readdy.ai/api/search-image?query=commercial%20building%20window%20installation%20project%2C%20professional%20window%20replacement%20for%20modern%20office%20building%2C%20large%20glass%20curtain%20wall%20facade%2C%20skilled%20workers%20on%20scaffolding%2C%20urban%20setting%2C%20architectural%20photography&width=600&height=400&seq=orpm-commercial-v2&orientation=landscape',
    },
    {
      icon: 'ri-shield-flash-line',
      titleKey: 'wns4_title',
      descKey: 'wns4_desc',
      features: ['wns4_f1', 'wns4_f2', 'wns4_f3', 'wns4_f4'],
      img: 'https://readdy.ai/api/search-image?query=impact%20resistant%20hurricane%20proof%20window%20installation%20on%20home%2C%20showing%20reinforced%20frame%20and%20laminated%20glass%2C%20storm%20protection%20home%20improvement%2C%20professional%20photography%20showing%20strong%20durable%20window%20product&width=600&height=400&seq=orpm-impact-v2&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('wns_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-4">
            {t('wns_title1')}<br />{t('wns_title2')}
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">{t('wns_desc')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {serviceTypes.map((service) => (
            <div key={service.titleKey} className="rounded-2xl overflow-hidden border border-slate-100 bg-white flex flex-col hover:border-sky-100 transition-all duration-300">
              <div className="h-52 overflow-hidden">
                <img src={service.img} alt={t(service.titleKey)} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-sky-50 rounded-xl flex items-center justify-center shrink-0">
                    <i className={`${service.icon} text-sky-600 text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-black text-slate-800">{t(service.titleKey)}</h3>
                </div>
                <p className="text-slate-500 text-sm leading-relaxed mb-5">{t(service.descKey)}</p>
                <ul className="grid grid-cols-2 gap-2 flex-1">
                  {service.features.map((fKey) => (
                    <li key={fKey} className="flex items-center gap-2 text-xs text-slate-700">
                      <div className="w-3.5 h-3.5 flex items-center justify-center shrink-0">
                        <i className="ri-check-line text-sky-500 text-sm font-bold"></i>
                      </div>
                      {t(fKey)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
